import { BulkAssignEmployeesToPolicyDocument } from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

import type { EmployeeSelectorV2MultiSelectState } from 'modules/employees/components/EmployeeSelectorV2/types'

interface UseBulkAssignEmployeesToPolicyParams {
  employeeSelection: EmployeeSelectorV2MultiSelectState
  payrollPolicyId: number
}

export const useBulkAssignEmployeesToPolicy = () => {
  const [bulkAssignEmployeesToPolicy, { loading }] = useMutation(
    BulkAssignEmployeesToPolicyDocument,
    {
      extractorFn: (data) => data.contractsMutations.bulkAssignContractsPayrollPolicy,
    }
  )

  return {
    fetching: loading,
    update({ employeeSelection, payrollPolicyId }: UseBulkAssignEmployeesToPolicyParams) {
      return bulkAssignEmployeesToPolicy({
        variables: {
          employeeSelection,
          payrollPolicyId,
        },
      })
    },
  }
}
